export default __webpack_public_path__ + "static/logo_licencjat-8a26fb2207b2f71b1cee2006f88258e3.png";